class Podcasts {
  constructor() {
    this.selectors = {
      item: '.js-staff-podcast',
      podcast: '.js-staff-podcast-audio',
      playButton: '.js-staff-podcast-play',
      time: '.js-staff-podcast-time',
    };

    this.DOM = {
      playButtons: document.querySelectorAll(this.selectors.playButton),
      podcasts: document.querySelectorAll(this.selectors.podcast),
    };

    if (!this.DOM.playButtons.length) {
      return;
    }

    this.classes = {
      playing: 'is-playing',
    };

    this.events();
    this.controls();
  }

  static getTime(value) {
    return value < 10 ? `0${value}` : value;
  }

  events() {
    this.DOM.podcasts.forEach((podcast) => {
      let duration = 0;
      let update = false;

      const timeElement = podcast
        .closest(this.selectors.item)
        .querySelector(this.selectors.time);
      const timeText = timeElement.innerText;

      const button = podcast.parentElement.querySelector(
        this.selectors.playButton,
      );

      podcast.addEventListener('loadeddata', (e) => {
        const minutes = Podcasts.getTime(parseInt(e.target.duration / 60, 10));
        const seconds = Podcasts.getTime(parseInt(e.target.duration % 60, 10));

        duration = `${minutes}:${seconds}`;
      });

      podcast.addEventListener('play', () => {
        update = true;
      });

      podcast.addEventListener('timeupdate', (e) => {
        const minutes = Podcasts.getTime(
          parseInt(e.target.currentTime / 60, 10),
        );
        const seconds = Podcasts.getTime(
          parseInt(e.target.currentTime % 60, 10),
        );

        const time = `${minutes}:${seconds}`;
        if (update) {
          timeElement.innerText = `${time}/${duration}`;
        }
      });

      podcast.addEventListener('ended', (e) => {
        e.target.pause();
        e.target.currentTime = 0;
        timeElement.innerText = timeText;
        button.classList.remove(this.classes.playing);
        update = false;
      });
    });
  }

  controls() {
    this.DOM.playButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const podcast = button.parentElement.querySelector(
          this.selectors.podcast,
        );

        if (podcast) {
          if (podcast.paused) {
            podcast.play();
            button.classList.add(this.classes.playing);
          } else {
            podcast.pause();
            button.classList.remove(this.classes.playing);
          }
        }
      });
    });
  }
}

export default new Podcasts();
